<script setup>
import { computed } from 'vue';

// Obtenemos el usuario de localStorage de manera segura
let user = null;
const storedUser = localStorage.getItem('user');
if (storedUser) {
  try {
    user = JSON.parse(storedUser);
  } catch (error) {
    console.error('Error al parsear el usuario de localStorage:', error);
  }
}

// Computada para determinar el enlace según el rol del usuario
const link = computed(() => {
  if (user && user.role === 'admin') {
    return '/dashboard';
  } else if (user && user.role === 'user') {
    return '/user/dashboard';
  }
  // Si no hay usuario o el rol no es reconocido, redirigir al login
  return '/login';
});
</script>

<template>
  <div class="flex flex-col items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900 px-4">
    <img src="/403.svg" alt="Acceso Denegado" class="w-5/6 max-w-md mx-auto" />
    <div class="text-center mt-8">
      <h1 class="text-4xl font-bold text-gray-800 dark:text-gray-300">Access Denied</h1>
      <p class="mt-4 text-lg text-gray-600 dark:text-gray-400">
        You don't have permission to access this page.
      </p>
      <router-link
          :to="link"
          class="mt-6 inline-block px-6 py-3 text-white bg-green-600 rounded-lg hover:bg-green-700 transition-colors duration-200"
      >
       Back to Home
      </router-link>
    </div>
  </div>
</template>

<style scoped>
/* Puedes agregar estilos adicionales aquí si es necesario */
</style>
